<template>
  <v-dialog v-model="dialogPlay" persistent max-width="430px">
    <v-card>
      <v-toolbar height="30px" flat>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('false')"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="d-flex flex-column justify-center align-center pa-3">
          <h3 class="text-center">
            Poin Anda tidak cukup
          </h3>
          <img height="200px" src="../../assets/img/gaming.svg" alt="" />
          <h3 class="text-center">Silakan bermain game untuk menambah poin</h3>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="indigo" dark @click="play">
          Main game <v-icon dark> mdi-play </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogPlay",
  props: ["dialogPlay", "goTo"],
  mounted() {
    console.log(this.$route.path);
  },
  methods: {
    play() {
      localStorage.setItem("from", this.$route.path);
      this.$router.push(this.goTo);
    }
  }
};
</script>

<style></style>
